import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {connect} from 'react-redux';
import {Motion, spring} from 'react-motion';
import TableHeadingComponent from '../components/common/TableHeadingComponent';
import SearchFieldComponent from '../components/common/SearchFieldComponent';
import LinkTableCellComponent from '../components/common/LinkTableCellComponent';
import TableRowGroupsComponent from '../components/common/TableRowGroupsComponent';

import deviceHeadings from '../data/tableHeadings/customerDevicesPage';
import devicesTestData from '../data/customerDevicesTestData';
import {setLoading} from '../redux/LoadingActions';
import {getCustomersPoliciesCall} from '../api/network/businessCustomerService';
import ColorTableCellComponent from '../components/common/ColorTableCellComponent';
import {filterObjectsBy} from '../utils';
import {sortCustomers} from '../utils/customersUtils';
import TableRowComponent from '../components/common/TableRowComponent';
import Pagination from '../components/common/Pagination';

const DevicesPageWrapper = styled.div`
    height: 90%;
    display: flex;
    overflow: hidden;
`;

const DevicesPageContent = styled.div`
    flex-grow: 1;
    overflow-y: scroll;
    padding-left: 32px;
    padding-bottom: 100px
`;

const TableCell = styled.span``;

const PageHeadingWrapper = styled.div`
    margin: 24px 8px;
    font-family: Metropolis,serif;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 20px;
    /* identical to box height, or 100% */
    
    /* default/gray/700 */
    color: var(--primary-text);
`;

const PaginationWrapper = styled.div`
    position: fixed;
    width: calc(150vw - var(--side-nav-width) - 298px);

    height: 52px;
    bottom: 0;
    //left: 0;
    //left: var(--side-nav-width);
    background: var(--white);
    box-shadow: 0px -4px 6px rgba(0, 0, 0, 0.1), 0px -2px 4px rgba(0, 0, 0, 0.06);    
    
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  
    padding: 0 32px;
    //margin-left: var(--side-nav-width);
`;

function CustomerDevices({user, ...props}) {
    // eslint-disable-next-line react/prop-types
    const {customerId, companyId} = user;

    const [query, setQuery] = useState('');

    const [paginationPage, setPaginationPage] = useState(0);
    const [paginationRowsPerPage, setPaginationRowsPerPage] = useState(10);

    const [policies, setPolicies] = useState([]);

    // on mounted
    useEffect(() => {
        console.log('fetching policies', policies);
        if (customerId && companyId) {
            // fetch contracts
            setLoading('Get_Policies', true);
            getCustomersPoliciesCall(companyId, customerId)
                .then(r => setPolicies(r))
                .catch(error => {
                })
                .finally(_ => {
                    setLoading('Get_Policies', false);
                });
        }
    }, [customerId, companyId]);

    const handleOnSearchChange = e => {
        setQuery(e.target.value);
    };

    const handleOnPageChange = page => {
        setPaginationPage(page);
    };

    const handleOnRowsPerPageChange = rowsPerPage => {
        setPaginationRowsPerPage(rowsPerPage);
        setPaginationPage(0);
    };

    const configureTableData = policiesData => policiesData.map(policyItem => {
        const deviceNameArray = policyItem.deviceName.split(' ');
        const color = deviceNameArray.splice(3, 1); //deviceNameArray[3];
        const deviceName = deviceNameArray.join(' ');

        return {
            ...policyItem,
            tableFieldData: {
                devices: <LinkTableCellComponent name={deviceName}/>,
                color: <ColorTableCellComponent color={color}/>,
                imei: <TableCell>{policyItem.imei}</TableCell>,
                policyId: <LinkTableCellComponent name={policyItem.policyNumber}/>,
                contract: <LinkTableCellComponent name={policyItem.contractId}/>,
            }
        };
    });

    const deviceToDisplay = configureTableData(policies);

    // Apply search filter
    let devices = [...deviceToDisplay];
    if (query) devices = filterObjectsBy(devices, ['deviceName', 'policyNumber', 'imei', 'id', 'contractId'], query);

    const sortedPolicies = sortCustomers(devices);

    const start = paginationPage * paginationRowsPerPage;
    const end = (paginationPage + 1) * paginationRowsPerPage;
    const paginatedDevices = sortedPolicies.slice(start, end);

    // Pagination functions and variables
    const paginationCount = deviceToDisplay.length;

    return (
        <DevicesPageWrapper>
            <DevicesPageContent>
                <PageHeadingWrapper>
                    Policies
                </PageHeadingWrapper>

                <SearchFieldComponent
                    onSearchChange={handleOnSearchChange}
                    placeholder="Filter by policy ID, IMEI, customer name or company"
                />

                {/*  Devices Table  */}
                <TableHeadingComponent tableHeadings={deviceHeadings} hasCheckBox={false}/>

                {
                    // {tableHeadings, rowData, isSelected, onCheckBoxSelected, hasCheckBox}
                    paginatedDevices.map((item, key) => (
                        <>
                            <TableRowComponent
                                key={`key-${key}${new Date().getTime()}`}
                                tableHeadings={deviceHeadings}
                                rowData={item.tableFieldData}
                                hasCheckBox={true}
                                onCheckBoxSelected={() => {}}
                            />

                            {/*<div style={{height: '32px'}} />*/}
                        </>
                    ))
                }

            </DevicesPageContent>

            {/**
             * Pagination Section
             **/}
            <Motion
                defaultStyle={{y: 200}}
                style={{y: spring(paginationCount >= 1 ? 0 : 200)}}
            >
                {
                    style => (
                        <PaginationWrapper
                            style={{transform: `translateY(${style.y}px)`, }}
                        >
                            <Pagination
                                count={paginationCount}
                                page={paginationPage}
                                rowsPerPage={paginationRowsPerPage}
                                onChangePage={handleOnPageChange}
                                onRowsPerPageChange={handleOnRowsPerPageChange}
                            />
                        </PaginationWrapper>
                    )
                }
            </Motion>

        </DevicesPageWrapper>
    );
}

CustomerDevices.propTypes = {};
CustomerDevices.defaultProps = {};

const mapStateToProps = state => ({user: state.user});

export default connect(mapStateToProps)(CustomerDevices);
